import { ERefreshTokenActions } from '../actions/refresh-token.actions';
import { RefreshTokenActions } from '../actions/refresh-token.actions';
import { initialRefreshTokenState, RefreshTokenState } from '../state/refresh-token.state';

export function refreshTokenReducer(state: RefreshTokenState = initialRefreshTokenState, action: RefreshTokenActions): RefreshTokenState {
  switch (action.type) {
    case ERefreshTokenActions.RefreshTokenSuccess: {
      return { ...state, customerToken: action.payload };
    }

    default:
      return state;
  }
};
